import axios from "axios";

export const getVideoThumbnail = (videoId) =>
  axios({
    method: "GET",
    url: `https://vimeo.com/api/v2/video/${videoId}.json`,
  });
